import { modalActions, userActions } from '@/actions';
import { showNavigationDrawer } from '@/actions/navigationDrawerActions';
import { isServer, url } from '@/helpers';
import { LoginContextType } from '@/hooks/useLogin';
import { LoginSignupFlowInitiatedFrom } from '@/types/analytics';
import { NavItemIdentifier } from '@/types/navigation';
import { Dispatch } from 'redux';

type LoginContext = LoginContextType & { initiatedFrom: LoginSignupFlowInitiatedFrom };

export const handleLogoutClick = async (dispatch: Dispatch<any>) => {
  dispatch(userActions.logout());
};

export const handleLoginClick = async (dispatch: Dispatch<any>, loginContext?: LoginContext) => {
  if (!isServer && loginContext) {
    dispatch(modalActions.login({ show: true, loginContext, initiatedFrom: loginContext.initiatedFrom }));
  }
};

const handleHamburgerClick = (dispatch) => {
  dispatch(showNavigationDrawer({ show: true }));
};

export const handleNavItemClicked =
  (dispatch: Dispatch<any>, screenName, loginContext?: LoginContext) => (identifier: NavItemIdentifier) => () => {
    if (identifier === NavItemIdentifier.Logout) return handleLogoutClick(dispatch);
    if (identifier === NavItemIdentifier.LogIn) return handleLoginClick(dispatch, loginContext);
    if (identifier === NavItemIdentifier.Hamburger) return handleHamburgerClick(dispatch);
  };

export const getScreenName = (propSource?: string) => {
  const source = propSource ?? 'outside';
  return source === 'list' || source === 'mapview'
    ? `search_results${source === 'list' ? '' : '_map'}`
    : isServer
    ? ''
    : url.getScreenNameFromUrl(window?.location?.href);
};
